// import third party
import { isEmpty } from 'lodash';
import { Box, Button, Flex } from '@chakra-ui/react';

// import local
import { tableHeadListsProductBundle } from './table/const';
import { useBundleStore } from '@pages/UploadMappingV2/hooks/state/useAddProductBundle';
import { useConfirmModal } from '@store/useConfirmModal';
import useMutateUploadMapping from '@pages/UploadMappingV2/hooks/mutate/useMutateUploadMapping';
import TableListProduct from '@pages/UploadMappingV2/components/Table/TableListProduct';
import ModalConfirmAddProduct from '@pages/UploadMappingV2/components/ModalConfirmAddProduct';
import ModalAddProductBundle from '@pages/UploadMappingV2/components/ModalAddProductBundle';
import { useApp } from '@pages/UploadMappingV2/context/AppContext';

export default function ProductBundle() {
    const { createNewBundle, bundles, directBundles, isDirectEditing, resetBundles } = useBundleStore();
    const { set } = useConfirmModal();
    const { uploadProductBundle, editProductBundle } = useMutateUploadMapping();
    const {
        isOpenModalConfirmAddProductBundle,
        onOpenModalConfirmAddProductBundle,
        onCloseModalConfirmAddProductBundle,
        onOpenModalAddProductBundle,
    } = useApp();

    const handleSubmitMapping = () => {
        if (isEmpty(bundles)) {
            return set({
                isOpen: true,
                title: 'Belum ada product yang ditambahkan',
                desc: 'Tambahkan minimal 1 produk untuk menyimpan mapping.',
                btnLabelYes: 'Mengerti',
                isShowBtnNo: false,
            });
        }
        onOpenModalConfirmAddProductBundle();
    };

    const handleConfirmSave = () => {
        if (isDirectEditing) {
            const payload = directBundles.map(({ id, created_at, ...rest }) => ({
                ...rest,
                items: rest.items.map(({ id, created_at, ...itemRest }) => itemRest),
            }))[0];
            editProductBundle.mutate({ id: directBundles[0].id, payload: { bundle: payload } });
        } else {
            const payload = bundles.map(({ id, ...rest }) => ({
                ...rest,
                items: rest.items.map(({ id, ...itemRest }) => itemRest),
            }));
            uploadProductBundle.mutate({ payload: { bundle: payload, piece: [] } });
        }
    };

    const handleCancelSave = () => {
        onCloseModalConfirmAddProductBundle();
        resetBundles();
    };

    const handleAddBundle = () => {
        createNewBundle();
        onOpenModalAddProductBundle();
    };

    return (
        <Box>
            <ModalAddProductBundle />

            <ModalConfirmAddProduct
                isOpen={isOpenModalConfirmAddProductBundle}
                onClose={handleCancelSave}
                onSubmit={handleConfirmSave}
            />

            <TableListProduct
                tableData={bundles}
                tableHeadLists={tableHeadListsProductBundle}
                isDefaultExpanded
                isShowEmptyState={false}
                onAddBtnClick={handleAddBundle}
            />
            <Flex justifyContent={'end'} mt={'24px'}>
                <Button px={'32px'} onClick={handleSubmitMapping}>
                    Simpan Mapping
                </Button>
            </Flex>
        </Box>
    );
}
